import React, { useState, useEffect, useRef } from 'react';
import { VscFilter } from 'react-icons/vsc';
import './ColumnFilter.css';

export default function ColumnFilter({ type, value, options, onChange }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const ref = useRef(null);
  const btnRef = useRef(null);
  const [pos, setPos] = useState(null);

  const active = type === 'text'
    ? (value != null && value !== '')
    : (value instanceof Set);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const toggle = (e) => {
    e.stopPropagation();
    if (open) { setOpen(false); return; }
    const rect = btnRef.current.getBoundingClientRect();
    setPos({ top: rect.bottom + 2, left: Math.min(rect.left, window.innerWidth - 200) });
    setOpen(true);
    setSearch('');
  };

  if (type === 'text') {
    return (
      <span ref={ref} className="col-filter">
        <span ref={btnRef}
          className={`col-filter-btn${active ? ' col-filter-active' : ''}`}
          onClick={toggle}
          onMouseDown={e => { e.stopPropagation(); e.preventDefault(); }}>
          <VscFilter />
        </span>
        {open && pos && (
          <div className="col-filter-popup" style={{ top: pos.top, left: pos.left }}
               onKeyDown={e => e.stopPropagation()}>
            <input
              autoFocus
              className="col-filter-input"
              value={value || ''}
              onChange={e => onChange(e.target.value || undefined)}
              placeholder="Filter…"
              onKeyDown={e => { if (e.key === 'Escape') setOpen(false); e.stopPropagation(); }}
            />
            {active && (
              <button className="col-filter-clear" onClick={() => { onChange(undefined); setOpen(false); }}>Clear</button>
            )}
          </div>
        )}
      </span>
    );
  }

  const allValues = options || [];
  const checkedSet = value instanceof Set ? value : new Set(allValues.map(o => o.value));

  const toggleValue = (val) => {
    const next = new Set(checkedSet);
    next.has(val) ? next.delete(val) : next.add(val);
    if (next.size === allValues.length) onChange(undefined);
    else onChange(next);
  };

  const filtered = search
    ? allValues.filter(o => o.label.toLowerCase().includes(search.toLowerCase()))
    : allValues;

  return (
    <span ref={ref} className="col-filter">
      <span ref={btnRef}
        className={`col-filter-btn${active ? ' col-filter-active' : ''}`}
        onClick={toggle}
        onMouseDown={e => { e.stopPropagation(); e.preventDefault(); }}>
        <VscFilter />
      </span>
      {open && pos && (
        <div className="col-filter-popup col-filter-select" style={{ top: pos.top, left: pos.left }}
             onKeyDown={e => e.stopPropagation()}>
          {allValues.length > 6 && (
            <input
              autoFocus
              className="col-filter-input"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search…"
            />
          )}
          <div className="col-filter-actions">
            <button onClick={() => onChange(undefined)} disabled={!active}>All</button>
            <button onClick={() => onChange(new Set())} disabled={checkedSet.size === 0}>None</button>
          </div>
          <div className="col-filter-list">
            {filtered.map(opt => (
              <label key={opt.value} className="col-filter-option">
                <input type="checkbox" checked={checkedSet.has(opt.value)} onChange={() => toggleValue(opt.value)} />
                <span className="col-filter-label">{opt.label}</span>
              </label>
            ))}
            {filtered.length === 0 && <div className="col-filter-empty">No matches</div>}
          </div>
        </div>
      )}
    </span>
  );
}
